import React from 'react'
import { useTranslation } from 'react-i18next';
// import { useTranslation } from 'react-i18next';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

export default function Sidebar() {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Determine if the link should be active
  const isActive = (path) => {
    const currentPath = location.pathname;
    return currentPath.startsWith(path);
  };

  return (
    <div className='sidebar'>
      <div className='sidebar-menu'>
        <ul>
          <li>
            <NavLink
              to={'/doctor/dashboard/1'}
              className={isActive('/doctor/dashboard/1') ? 'active' : ''}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.45 11.5497L15.5 9.49966M10 12.9997C10 13.5301 10.2107 14.0388 10.5858 14.4139C10.9609 14.789 11.4696 14.9997 12 14.9997C12.5304 14.9997 13.0391 14.789 13.4142 14.4139C13.7893 14.0388 14 13.5301 14 12.9997C14 12.4692 13.7893 11.9605 13.4142 11.5855C13.0391 11.2104 12.5304 10.9997 12 10.9997C11.4696 10.9997 10.9609 11.2104 10.5858 11.5855C10.2107 11.9605 10 12.4692 10 12.9997ZM6.4 19.9997C4.93815 18.8377 3.87391 17.2499 3.35478 15.4561C2.83564 13.6624 2.88732 11.7516 3.50265 9.98847C4.11797 8.2254 5.26647 6.69737 6.78899 5.61616C8.3115 4.53495 10.1326 3.9541 12 3.9541C13.8674 3.9541 15.6885 4.53495 17.211 5.61616C18.7335 6.69737 19.882 8.2254 20.4974 9.98847C21.1127 11.7516 21.1644 13.6624 20.6452 15.4561C20.1261 17.2499 19.0619 18.8377 17.6 19.9997H6.4Z" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>


              <span>{t('Dashboard')}</span>
            </NavLink>

          </li>
          <li>
            <NavLink
              to={'/doctor/profile'}
              className={isActive('/doctor/profile') ? 'active' : ''}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span>{t('My Profile')}</span>
            </NavLink>

          </li>
          <li>
            <NavLink
              to={'/doctor/settings/patient/1'}
              className={isActive('/doctor/settings/patient') || isActive('/doctor/patient/appointment/') || isActive('/doctor/patient/medical-history/view')  || isActive('/doctor/patient/diet-chart/add') ? 'active' : ''}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{t('Patient Management')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={'/doctor/consultation-history/1'}
              className={isActive('/doctor/consultation-history') || isActive('/doctor/consultation/prescription/add')    || isActive('/doctor/consultation/prescription/edit/') || isActive('/doctor/consultation/medical-history/view') || isActive('/doctor/consultation/prescription/view') ? 'active' : ''}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 7H15M9 11H15M9 15H13M5 5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5Z" stroke="#354052" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

              <span>{t('Consultation History')}</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  )
}
